export class ExternalApiSummary {
    id: number;
    slug: string;
    date: string;
    created: number;
    updated: number;
    deleted: number;
}